<template>
  <div>
    <app-header title="" />

    <div class="container my-5">
      <div class="d-flex justify-content-between align-items-center mb-4">
        <h2>Un-Invoiced Work</h2>
        <p class="mb-0 text-muted">{{ entries.length }} Results Returned</p>
      </div>

      <div class="input-group mb-4">
        <input type="text" class="form-control" placeholder="Search client, user story or task ...">
        <button class="btn btn-success" type="button">Search</button>
      </div>

      <c-data-list :items="entries">
        <template v-slot:columns>
          <div class="col-11">Client</div>
          <div class="col-1"></div>
        </template>
        <template v-slot:default="slotProps">
          <uninvoiced-detail :client="slotProps.item" />
        </template>
      </c-data-list>
    </div>
  </div>
</template>

<script>

    import { mapState, mapActions } from 'vuex'
    import UninvoicedDetail from 'components/invoices/uninvoiced/_details'

    export default {
        data: function () {
            return {
                projects: [],
                loading: true,
                search_string: '',
                searching: false,
				filters: {},
				focusClientId: null,
            }
        },
        computed: {
            ...mapState('uninvoiced', {entries: 'list'}),
        },
        created: function() {
            this.getList(this.filters)
        },
        methods: {
			...mapActions('uninvoiced', ['getList']), 
		},

        components: {
            UninvoicedDetail
		}
    }
</script>

